import React, { PureComponent } from 'react';

import Button from 'widgets/Button';
import FoodProfileToggles from 'apps/foodProfile/components/FoodProfileToggles';

export default class FoodProfileStep2 extends PureComponent {
  render() {
    return (
      <div className="js-foodProfilePopup__step2">
        <div className="js-foodProfilePopup__headerBar">
          <h3>Set up Food Profile</h3>
          <Button
            className="js-createFoodProfileClose"
            onClick={this.props.closeHandler}
          />
        </div>
        <p>
          Tell us what you can’t eat by moving the toggle button next to an ingredient
          to the right. If the toggle is purple, that means you’ve told us
          you can’t consume that ingredient.
        </p>
        <p>
          So you’re aware: this service doesn’t work with alcohol;
          pet and baby food; medication and supplements just yet,
          so please take care to check the ingredients on those products.
        </p>
        <p>
          You can always edit your selection later from your Account Settings.
        </p>
        <FoodProfileToggles
          values={this.props.values}
          conditions={this.props.conditions}
          onChange={this.props.onChange}
        />
        <div className="js-foodProfilePopup__actionBar">
          <a href="https://www.foodmaestro.me/">Powered by Foodmaestro</a>
          <Button onClick={this.props.nextStepHandler}>Next</Button>
        </div>
        <div className="gn-multiStepIndicator js-foodProfilePopup__stepIndicator">
          <span className="filled" />
          <span className="filled" />
          <span />
        </div>
      </div>
    );
  }
}
